<template>
  <span v-if="isAdmin">
    <el-button size="small" @click="open">公海回收规则</el-button>
    <el-dialog title="公海自动回收" :visible.sync="visible" width="560px" append-to-body>
      <el-alert title="0 表示关闭。启用后每小时扫描一次，按最近跟进及最近领取或转交时间计算；已转化线索、存在进行中或成交商机及有效合同的客户不回收。" type="info" :closable="false" />
      <el-form label-width="130px" style="margin-top:20px" v-loading="loading">
        <el-form-item label="线索未跟进天数"><el-input-number v-model="form.leadDays" :min="0" :max="3650" :precision="0" /></el-form-item>
        <el-form-item label="客户未跟进天数"><el-input-number v-model="form.customerDays" :min="0" :max="3650" :precision="0" /></el-form-item>
      </el-form>
      <div slot="footer"><el-button @click="visible=false">关闭</el-button><el-button :loading="running" @click="recycle">按已保存规则立即回收</el-button><el-button type="primary" :loading="saving" @click="save">保存规则</el-button></div>
    </el-dialog>
  </span>
</template>
<script>
import { crm } from '../api/crm'
export default {
  name: 'CrmPoolSettings',
  data() { return { visible: false, form: { leadDays: 0, customerDays: 0 }, loading: false, saving: false, running: false } },
  computed: { isAdmin() { const u = this.$store.state.user || {}; return ['TENANT_ADMIN', 'PLATFORM_ADMIN'].some(r => u.roleCode === r || (u.roleCodes || []).includes(r)) } },
  methods: {
    async open() {
      this.visible = true; this.loading = true
      try { const res = await crm.poolSettings(); this.form = res.data } finally { this.loading = false }
    },
    async save() {
      this.saving = true
      try { await crm.savePoolSettings(this.form); this.$message.success('回收规则已保存') } finally { this.saving = false }
    },
    async recycle() {
      try { await this.$confirm('按已保存的规则扫描当前企业并回收符合条件的资源，是否确认？', '立即回收', { type: 'warning' }) } catch (_) { return }
      this.running = true
      try { const res = await crm.recyclePool(); this.$message.success(`已回收线索 ${res.data.LEAD} 条、客户 ${res.data.CUSTOMER} 条`); this.$emit('changed') } finally { this.running = false }
    }
  }
}
</script>
